import { getThemeColor, Styles } from "@mcleod/core";

export const FabStyles = Styles.make("fab", () => {
    return {
        fabBase: {
            position: "fixed",
            width: "auto",
            minHeight: 48,
            bottom: "48px",
            right: "36px",
            backgroundColor: getThemeColor("primary"),
            transition: "background-color 0.3s, box-shadow 0.3s",
        },
    };
});
